import React, { useState } from "react";
import { LoadingIcon } from "../../../components";
import { SpinachTable } from "./Table";
import LeafSizeContent from "./LeafSizeContent";
import HeatMapContent from "./HeatMapContent";
import { Tabs } from "antd";

const DashboardContent = ({
  currentOrg,
  currentSite,
  graphData,
  allRowGraphData,
  dropdownLoading,
  dateList,
  siteMetadata,
  currentCrop,
  currentGreenhouse,
  currentPlot,
  plotData,
  activeTab,
  setActiveTab,
  greenHouseLabel,
  blockLabel,
}) => {
  const [tableData, setTableData] = useState([]);
  const [allRowTableData, setAllRowTableData] = useState({});

  if (dropdownLoading) {
    return <LoadingIcon height="200px" />;
  }

  const tabItems = [
    {
      label: "Leaf Size",
      key: "leafSize",
      children: (
        <LeafSizeContent
          currentOrg={currentOrg}
          currentSite={currentSite}
          graphData={graphData}
          allRowGraphData={allRowGraphData}
          dropdownLoading={dropdownLoading}
          dateList={dateList}
          siteMetadata={siteMetadata}
          currentCrop={currentCrop}
          currentGreenhouse={currentGreenhouse}
          currentPlot={currentPlot}
          tableData={tableData}
          allRowTableData={allRowTableData}
          greenHouseLabel={greenHouseLabel}
          blockLabel={blockLabel}
        />
      ),
    },
    {
      label: "Heat Map",
      key: "heatMap",
      children: (
        <HeatMapContent
          currentOrg={currentOrg}
          currentSite={currentSite}
          dropdownLoading={dropdownLoading}
          dateList={dateList}
          siteMetadata={siteMetadata}
          currentCrop={currentCrop}
          currentGreenhouse={currentGreenhouse}
          currentPlot={currentPlot}
        />
      ),
    },
  ];

  return (
    <div className="w-full flex flex-col items-center">
      {/* Table Section */}
      <SpinachTable
        currentSite={currentSite}
        currentCrop={currentCrop}
        currentGreenhouse={currentGreenhouse}
        currentOrg={currentOrg}
        currentPlot={currentPlot}
        tableData={tableData}
        setTableData={setTableData}
        plotData={plotData}
        setAllRowTableData={setAllRowTableData}
      />

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        className="w-full"
        tabBarStyle={{ width: "100%" }}
        items={tabItems}
      />
    </div>
  );
};

export default DashboardContent;
